function getUtmTestData(type) {
	let data = {
		manual: {
			utm: [
				'https://localhost:3000/?utm_source=111',
				'https://localhost:3000/?utm_source=112&utm_medium=211',
				'https://localhost:3000/?utm_source=113&utm_campaign=311',
				'https://localhost:3000/?utm_source=114&utm_medium=213&utm_campaign=312',
				'https://localhost:3000/resources/banking-industry-overview/?utm_source=tsource&utm_medium=tmedium&utm_campaign=DEMO2021&utm_term=%2Bdata%2Brobot&utm_content=variation4',
				'https://localhost:3000/?gclid=411',
				'https://localhost:3000/?utm_source=115&gclid=412',
				'https://localhost:3000/?utm_source=116&utm_medium=214&gclid=413',
				'https://localhost:3000/?utm_source=117&utm_campaign=313&gclid=414',
				'https://localhost:3000/?utm_source=118&utm_medium=215&utm_campaign=314&gclid=415',
				'https://localhost:3000/?fbclid=1234',
				'https://localhost:3000/?li_fat_id=1234',
			],
			marketo: [
				'https://localhost:3000/webinars/combating-aml-compliance-problem/?utm_content=Event%20Reminder%20&utm_campaign=FY22-Q2-GLOB-FD-FIN-TRANSFORMING-AML-AND-KY-EXW&utm_medium=email-marketing&utm_source=marketo&utm_term=Banking%20and%20Finance%20Customers%20and%20Prospects&utm_source=automationanywhere&utm_medium=techalliance&utm_campaign=WAARPA21A&mkt_tok=MDQ1LUxRUy0wMjIAAAF8T8vba-SYckl5Z2G3yK4o_VoPfLL_5L9wPK7D1LDj8-Z5WemHTjTpdFUXcsvB4mYOUUJ3d-YNScTbymK5TLWjJnCdNRlHK4jNrr1UgyHDlmXe8g',
				'https://localhost:3000/preference-center/?email=natali.surhova@datarobot.com&mkt_tok=Nzg5LVVXVi01OTcAAAF8S0kjEjN4RARju0aReAyH7vnzQFSUQah4Ezf88yvpv7qcOOBmLzqYRi1qhobtADi85WKu305h3c07n-Iha4zNN8aO2Q9hIkbpgbUrl8S0BYY'
			],
		},
		referral: {
			'(none)': [
				'https://pathfinder.datarobot.com/',
				'https://community.datarobot.com/',
			],
			social: [
				'https://www.facebook.com/',
				'https://www.l.facebook.com/',
				'https://www.m.facebook.com/',
				'https://www.lm.facebook.com/',
				'https://www.ja-jp.facebook.com/',
				'https://www.instagram.com/',
				'https://www.linkedin.com/',
				'https://www.youtube.com/',
				'https://twitter.com/',
				'https://t.co/',
			],
			organic: [
				'https://www.google.com/',
				'https://www.google.com.ua/',
				'https://www.google.de/',
				'https://www.ask.com/',
				'https://nortonsafe.search.ask.com/',
				'https://int.search.tb.ask.com/',
				'https://www.search.ask.com/',
				'https://www.baidu.com/',
				'https://www.m.baidu.com/',
				'https://duckduckgo.com/',
				'https://html.duckduckgo.com/',
				'https://www.ecosia.org/search?q=datarobot',
				'https://search.lycos.com/',
				'https://search14.lycos.com/',
				'https://www.bing.com/',
				'https://www2.bing.com/',
				'https://m2.cn.bing.com/',
				'https://cn.bing.com/',
				'https://sogou.com/',
				'https://english.sogou.com/',
				'https://startpage.com/',
				'https://webcrawler.com/',
				'https://search.yahoo.com/',
				'https://search.yahoo.co.jp/',
				'https://yandex.ru/',
				'https://yandex.com.tr/',
				'https://search.daum.net/',
				'https://search.naver.com/',
				'https://search.aol.com/',
				'https://r.search.aol.com/',
				'https://search.seznam.cz/',
				'https://websearch.rakuten.co.jp/',
				'https://cgi.search.biglobe.ne.jp/',
				'https://search.goo.ne.jp/',
				'https://search.smt.docomo.ne.jp/',
				'https://news.search.smt.docomo.ne.jp/',
				'https://szukaj.onet.pl/',
				'https://www.kvasir.no/alle?q=datarobot',
				'https://www.startsiden.no/',
				'https://search.centrum.cz/',
				'https://search.tut.by/',
				'https://www.so.com/',
				'https://search.auone.jp/',
			],
			referral: [
				'https://www.github.com/',
				'https://www.mail.google.com/',
				'https://maps.google.com/',
				'https://google.community.com/',
				'https://googleaps.com/',
				'https://www.flask.com/',
				'https://map.baidu.com/',
				'https://me.baidu.com/',
				'https://www.mail.lycos.com/',
				'http://sg.news.yahoo.com/',
				'https://map.yahoo.co.jp/',
				'https://mail.yandex.by/',
				'https://mail.daum.net/',
				'https://section.blog.naver.com/',
				'https://mail.aol.com/',
				'https://slovnik.seznam.cz/',
				'https://travel.rakuten.co.jp/',
				'https://auth.sso.biglobe.ne.jp/mail/',
				'https://news.goo.ne.jp/',
				'https://service.smt.docomo.ne.jp/portal/search/src/search_how.html',
				'https://gameplanet.onet.pl/',
				'https://mail.tut.by/',
				'http://news.so.com/',
				'https://article.auone.jp/',
			],
		}
	};

	return data[type];
}

module.exports = getUtmTestData;
